import React from 'react'
import { List, useListRepository } from 'elentari'
import GestoresCentroCustoRepository from './GestoresCentroCustoRepository'

export default function GestoresCentroCusto(props) {
  const listOptions = {
    defaultOrder: 'data',
    fields: {
      id: {
        label: 'Id'
      },
      gestor: {
        label: 'Gestor',
        format: gestor => gestor.usuario
      }
    }
  }
  const listHook = useListRepository({
    repository: GestoresCentroCustoRepository,
    path: 'gestores'
  })
  listHook.onClickEdit = null
  listHook.onClickNew = props.onClickNew
  return (
    <List
      {...props}
      {...listHook}
      hideDownloadIcon
      listOptions={listOptions}
      onClickView={null}
    />
  )
}
